unit SystemLedgerAccountSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.DBCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client;

type
  TfrmSystemLedgerAccountSetup = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebButton2: TButton;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    wcSystemLedgerAccounts: TXDataWebClient;
    wdsSystemLedgerAccounts: TXDataWebDataSet;
    dsSystemLedgerAccounts: TDataSource;
    wdsSystemLedgerAccountsfleettype: TIntegerField;
    wdsSystemLedgerAccountsvaluetype: TIntegerField;
    wdsSystemLedgerAccountssystemtype: TIntegerField;
    wdsSystemLedgerAccountscompanygldetail_Auto: TIntegerField;
    btnSystemTypesSearch: TButton;
    edtSystemTypes: TEdit;
    btnSearchFleetType: TButton;
    WebButton4: TButton;
    WebButton5: TButton;
    edtFleetType: TEdit;
    edtValueType: TEdit;
    edtGLDescription: TEdit;
    wdsSystemLedgerAccountsglcode: TStringField;
    wcCompanyGL: TXDataWebClient;
    wdsCompanyGL: TXDataWebDataSet;
    WebLabel6: TLabel;
    wdsCompanyGLGLDESCRIPTION: TStringField;
    wdsCompanyGLFleetDesc: TStringField;
    wdsCompanyGLValueTypesDesc: TStringField;
    wdsCompanyGLSystemDesc: TStringField;
    wdsCompanyGLGLCode: TStringField;
    wdsCompanyGLCompanygldetail_Auto: TIntegerField;
    procedure WebFormShow(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure btnSystemTypesSearchClick(Sender: TObject);
    procedure btnSearchFleetTypeClick(Sender: TObject);
    procedure WebButton4Click(Sender: TObject);
    procedure WebButton5Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    iState : Integer;
    sGlcode : String;
    iAuto : Integer;
  protected procedure LoadDFMValues; override; end;

var
  frmSystemLedgerAccountSetup: TfrmSystemLedgerAccountSetup;

implementation

{$R *.dfm}

uses
  stfmssystem.connection , share.system.classes , share.common, Search.SystemTypes, Search.FleetTypes, Search.ValueTypes, Search.GLAccounts;

procedure TfrmSystemLedgerAccountSetup.btnSearchFleetTypeClick(Sender: TObject);
  var
    newform : TfrmSearchFleetTypes;

    procedure AfterShowModal(AValue: TModalResult);
      begin
        with newform do
          begin
            if iAutoNo > -1 then
              begin
                edtFleetType.Text := sDescription;

                wdsSystemLedgerAccounts.FieldByName('fleettype').AsInteger := iAutoNo;

                console.log(GetJsonFromDataSet(wdsSystemLedgerAccounts));
              end
            else
              begin
                edtSystemTypes.Text := '';
                //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
              end;
          end;
      end;

begin
  newform := TfrmSearchFleetTypes.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmSystemLedgerAccountSetup.btnSystemTypesSearchClick(
  Sender: TObject);
  var
    newform : TfrmSystemTypesSearch;

    procedure AfterShowModal(AValue: TModalResult);
      begin
        with newform do
          begin
            if iSystemNo > -1 then
              begin
                edtSystemTypes.Text := sDescription;

                //wdsSystemLedgerAccounts.FieldByName('systemtype').AsInteger
                wdsSystemLedgerAccounts.FieldByName('systemtype').AsInteger := iSystemNo;

                WebLabel6.Caption := IntToStr(iSystemNo);
                console.log(GetJsonFromDataSet(wdsSystemLedgerAccounts));
              end
            else
              begin
                edtSystemTypes.Text := '';
                //wdsSystemLedgerAccounts.FieldByName('SystemNO').AsInteger := ;
              end;
          end;
      end;

begin
  newform := TfrmSystemTypesSearch.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmSystemLedgerAccountSetup.WebButton1Click(Sender: TObject);
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsSystemLedgerAccounts.Cancel;
      Close;
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
      Close;
    end;

begin
  Case iState of
    1 : Begin
          wcSystemLedgerAccounts.RawInvoke('IstfmsSystemService.Put_SystemLedgerAccounts_Insert',[GetJsonFromDataSet(wdsSystemLedgerAccounts)],@OnSuccess,@OnError);
        End;
    2 : Begin
          wcSystemLedgerAccounts.RawInvoke('IstfmsSystemService.Put_CompanyGLDetails_Edit',[GetJsonFromDataSet(wdsSystemLedgerAccounts)],@OnSuccess,@OnError);
        End;

  end;
end;

procedure TfrmSystemLedgerAccountSetup.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmSystemLedgerAccountSetup.WebButton4Click(Sender: TObject);
  var
    newform : TfrmValueTypes;

    procedure AfterShowModal(AValue: TModalResult);
      begin
        with newform do
          begin
            if iAutoNo > -1 then
              begin
                edtValueType.Text := sDescription;

                wdsSystemLedgerAccounts.FieldByName('valuetype').AsInteger := iAutoNo;

                console.log(GetJsonFromDataSet(wdsSystemLedgerAccounts));
              end
            else
              begin
                edtSystemTypes.Text := '';
              end;
          end;
      end;

begin
  newform := TfrmValueTypes.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmSystemLedgerAccountSetup.WebButton5Click(Sender: TObject);
  var
    newform : TfrmSearchGLA;

    procedure AfterShowModal(AValue: TModalResult);
      begin
        with newform do
          begin
            if sGlcode <> '' then
              begin
                edtGLDescription.Text := sDescription;

                wdsSystemLedgerAccounts.FieldByName('GLCODE').AsString := sGLCode;

                console.log(GetJsonFromDataSet(wdsSystemLedgerAccounts));
              end
            else
              begin
                edtSystemTypes.Text := '';

              end;
          end;
      end;
begin
  newform := TfrmSearchGLA.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmSystemLedgerAccountSetup.WebFormShow(Sender: TObject);
  procedure OnResultCompanyGL(Response : TXDataClientResponse);
    begin
      wdsCompanyGL.Close;
      wdsCompanyGL.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsCompanyGL.Open;

      edtSystemTypes.Text := wdsCompanyGL.FieldByName('SystemDesc').AsString;
      edtFleetType.Text := wdsCompanyGL.FieldByName('FleetDesc').AsString;
      edtValueType.Text := wdsCompanyGL.FieldByName('ValueTypesDesc').AsString;
      edtGLDescription.Text := wdsCompanyGL.FieldByName('GLDESCRIPTION').AsString;
    end;

  procedure OnResutSystemLedger(Response : TXDataClientResponse);
    Begin
      wdsSystemLedgerAccounts.Close;
      wdsSystemLedgerAccounts.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsSystemLedgerAccounts.Open;

      wdsSystemLedgerAccounts.Edit;

      wcCompanyGL.RawInvoke('IstfmsSystemService.Get_CompanyGL_View',[0,iAuto],@OnResultCompanyGL);    //////////////////////////
    End;

begin

  case iState of
    1 : Begin
          wdsSystemLedgerAccounts.Open;
          wdsSystemLedgerAccounts.Insert;
        End;

    2 : Begin
          wcSystemLedgerAccounts.RawInvoke('IstfmsSystemService.Get_CompanyGLDetailIndexes_View',[iAuto],@OnResutSystemLedger);
        End;

  end;

end;

procedure TfrmSystemLedgerAccountSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  btnSystemTypesSearch := TButton.Create(Self);
  edtSystemTypes := TEdit.Create(Self);
  btnSearchFleetType := TButton.Create(Self);
  WebButton4 := TButton.Create(Self);
  WebButton5 := TButton.Create(Self);
  edtFleetType := TEdit.Create(Self);
  edtValueType := TEdit.Create(Self);
  edtGLDescription := TEdit.Create(Self);
  wcSystemLedgerAccounts := TXDataWebClient.Create(Self);
  wdsSystemLedgerAccounts := TXDataWebDataSet.Create(Self);
  wdsSystemLedgerAccountsfleettype := TIntegerField.Create(Self);
  wdsSystemLedgerAccountsvaluetype := TIntegerField.Create(Self);
  wdsSystemLedgerAccountssystemtype := TIntegerField.Create(Self);
  wdsSystemLedgerAccountscompanygldetail_Auto := TIntegerField.Create(Self);
  wdsSystemLedgerAccountsglcode := TStringField.Create(Self);
  dsSystemLedgerAccounts := TDataSource.Create(Self);
  wcCompanyGL := TXDataWebClient.Create(Self);
  wdsCompanyGL := TXDataWebDataSet.Create(Self);
  wdsCompanyGLGLDESCRIPTION := TStringField.Create(Self);
  wdsCompanyGLFleetDesc := TStringField.Create(Self);
  wdsCompanyGLValueTypesDesc := TStringField.Create(Self);
  wdsCompanyGLSystemDesc := TStringField.Create(Self);
  wdsCompanyGLGLCode := TStringField.Create(Self);
  wdsCompanyGLCompanygldetail_Auto := TIntegerField.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  btnSystemTypesSearch.BeforeLoadDFMValues;
  edtSystemTypes.BeforeLoadDFMValues;
  btnSearchFleetType.BeforeLoadDFMValues;
  WebButton4.BeforeLoadDFMValues;
  WebButton5.BeforeLoadDFMValues;
  edtFleetType.BeforeLoadDFMValues;
  edtValueType.BeforeLoadDFMValues;
  edtGLDescription.BeforeLoadDFMValues;
  wcSystemLedgerAccounts.BeforeLoadDFMValues;
  wdsSystemLedgerAccounts.BeforeLoadDFMValues;
  wdsSystemLedgerAccountsfleettype.BeforeLoadDFMValues;
  wdsSystemLedgerAccountsvaluetype.BeforeLoadDFMValues;
  wdsSystemLedgerAccountssystemtype.BeforeLoadDFMValues;
  wdsSystemLedgerAccountscompanygldetail_Auto.BeforeLoadDFMValues;
  wdsSystemLedgerAccountsglcode.BeforeLoadDFMValues;
  dsSystemLedgerAccounts.BeforeLoadDFMValues;
  wcCompanyGL.BeforeLoadDFMValues;
  wdsCompanyGL.BeforeLoadDFMValues;
  wdsCompanyGLGLDESCRIPTION.BeforeLoadDFMValues;
  wdsCompanyGLFleetDesc.BeforeLoadDFMValues;
  wdsCompanyGLValueTypesDesc.BeforeLoadDFMValues;
  wdsCompanyGLSystemDesc.BeforeLoadDFMValues;
  wdsCompanyGLGLCode.BeforeLoadDFMValues;
  wdsCompanyGLCompanygldetail_Auto.BeforeLoadDFMValues;
  try
    Name := 'frmSystemLedgerAccountSetup';
    Width := 640;
    Height := 417;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 417;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 240;
    WebLabel1.Top := 80;
    WebLabel1.Width := 69;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'System Type:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 240;
    WebLabel2.Top := 144;
    WebLabel2.Width := 56;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Fleet Type:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 240;
    WebLabel3.Top := 210;
    WebLabel3.Width := 59;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Value Type:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel1);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 240;
    WebLabel4.Top := 280;
    WebLabel4.Width := 65;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'GL Account:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel1);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 472;
    WebLabel5.Top := 56;
    WebLabel5.Width := 58;
    WebLabel5.Height := 15;
    WebLabel5.Caption := 'WebLabel5';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(WebPanel1);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 472;
    WebLabel6.Top := 80;
    WebLabel6.Width := 58;
    WebLabel6.Height := 15;
    WebLabel6.Caption := 'WebLabel6';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 640;
    WebPanel2.Height := 40;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'System Ledger Accounts';
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 372;
    WebPanel3.Width := 640;
    WebPanel3.Height := 45;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 3;
    WebButton1.Top := 10;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Save';
    WebButton1.Color := clGreenyellow;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 129;
    WebButton2.Top := 10;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    btnSystemTypesSearch.SetParentComponent(WebPanel1);
    btnSystemTypesSearch.Name := 'btnSystemTypesSearch';
    btnSystemTypesSearch.Left := 391;
    btnSystemTypesSearch.Top := 95;
    btnSystemTypesSearch.Width := 26;
    btnSystemTypesSearch.Height := 25;
    btnSystemTypesSearch.Caption := '...';
    btnSystemTypesSearch.ChildOrder := 11;
    btnSystemTypesSearch.HeightPercent := 100.000000000000000000;
    btnSystemTypesSearch.WidthPercent := 100.000000000000000000;
    SetEvent(btnSystemTypesSearch, Self, 'OnClick', 'btnSystemTypesSearchClick');
    edtSystemTypes.SetParentComponent(WebPanel1);
    edtSystemTypes.Name := 'edtSystemTypes';
    edtSystemTypes.Left := 240;
    edtSystemTypes.Top := 96;
    edtSystemTypes.Width := 145;
    edtSystemTypes.Height := 22;
    edtSystemTypes.ChildOrder := 12;
    edtSystemTypes.HeightPercent := 100.000000000000000000;
    edtSystemTypes.WidthPercent := 100.000000000000000000;
    btnSearchFleetType.SetParentComponent(WebPanel1);
    btnSearchFleetType.Name := 'btnSearchFleetType';
    btnSearchFleetType.Left := 391;
    btnSearchFleetType.Top := 164;
    btnSearchFleetType.Width := 26;
    btnSearchFleetType.Height := 25;
    btnSearchFleetType.Caption := '...';
    btnSearchFleetType.ChildOrder := 13;
    btnSearchFleetType.HeightPercent := 100.000000000000000000;
    btnSearchFleetType.WidthPercent := 100.000000000000000000;
    SetEvent(btnSearchFleetType, Self, 'OnClick', 'btnSearchFleetTypeClick');
    WebButton4.SetParentComponent(WebPanel1);
    WebButton4.Name := 'WebButton4';
    WebButton4.Left := 391;
    WebButton4.Top := 230;
    WebButton4.Width := 26;
    WebButton4.Height := 25;
    WebButton4.Caption := '...';
    WebButton4.ChildOrder := 14;
    WebButton4.HeightPercent := 100.000000000000000000;
    WebButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton4, Self, 'OnClick', 'WebButton4Click');
    WebButton5.SetParentComponent(WebPanel1);
    WebButton5.Name := 'WebButton5';
    WebButton5.Left := 391;
    WebButton5.Top := 300;
    WebButton5.Width := 26;
    WebButton5.Height := 25;
    WebButton5.Caption := '...';
    WebButton5.ChildOrder := 15;
    WebButton5.HeightPercent := 100.000000000000000000;
    WebButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton5, Self, 'OnClick', 'WebButton5Click');
    edtFleetType.SetParentComponent(WebPanel1);
    edtFleetType.Name := 'edtFleetType';
    edtFleetType.Left := 240;
    edtFleetType.Top := 165;
    edtFleetType.Width := 145;
    edtFleetType.Height := 22;
    edtFleetType.ChildOrder := 16;
    edtFleetType.HeightPercent := 100.000000000000000000;
    edtFleetType.WidthPercent := 100.000000000000000000;
    edtValueType.SetParentComponent(WebPanel1);
    edtValueType.Name := 'edtValueType';
    edtValueType.Left := 240;
    edtValueType.Top := 231;
    edtValueType.Width := 145;
    edtValueType.Height := 22;
    edtValueType.ChildOrder := 17;
    edtValueType.HeightPercent := 100.000000000000000000;
    edtValueType.WidthPercent := 100.000000000000000000;
    edtGLDescription.SetParentComponent(WebPanel1);
    edtGLDescription.Name := 'edtGLDescription';
    edtGLDescription.Left := 240;
    edtGLDescription.Top := 301;
    edtGLDescription.Width := 145;
    edtGLDescription.Height := 22;
    edtGLDescription.ChildOrder := 18;
    edtGLDescription.HeightPercent := 100.000000000000000000;
    edtGLDescription.WidthPercent := 100.000000000000000000;
    wcSystemLedgerAccounts.SetParentComponent(Self);
    wcSystemLedgerAccounts.Name := 'wcSystemLedgerAccounts';
    wcSystemLedgerAccounts.Connection := dmData.dbConnect;
    wcSystemLedgerAccounts.Left := 520;
    wcSystemLedgerAccounts.Top := 112;
    wdsSystemLedgerAccounts.SetParentComponent(Self);
    wdsSystemLedgerAccounts.Name := 'wdsSystemLedgerAccounts';
    wdsSystemLedgerAccounts.Connection := dmData.dbConnect;
    wdsSystemLedgerAccounts.Left := 520;
    wdsSystemLedgerAccounts.Top := 144;
    wdsSystemLedgerAccountsfleettype.SetParentComponent(wdsSystemLedgerAccounts);
    wdsSystemLedgerAccountsfleettype.Name := 'wdsSystemLedgerAccountsfleettype';
    wdsSystemLedgerAccountsfleettype.FieldName := 'fleettype';
    wdsSystemLedgerAccountsvaluetype.SetParentComponent(wdsSystemLedgerAccounts);
    wdsSystemLedgerAccountsvaluetype.Name := 'wdsSystemLedgerAccountsvaluetype';
    wdsSystemLedgerAccountsvaluetype.FieldName := 'valuetype';
    wdsSystemLedgerAccountssystemtype.SetParentComponent(wdsSystemLedgerAccounts);
    wdsSystemLedgerAccountssystemtype.Name := 'wdsSystemLedgerAccountssystemtype';
    wdsSystemLedgerAccountssystemtype.FieldName := 'systemtype';
    wdsSystemLedgerAccountscompanygldetail_Auto.SetParentComponent(wdsSystemLedgerAccounts);
    wdsSystemLedgerAccountscompanygldetail_Auto.Name := 'wdsSystemLedgerAccountscompanygldetail_Auto';
    wdsSystemLedgerAccountscompanygldetail_Auto.FieldName := 'companygldetail_Auto';
    wdsSystemLedgerAccountsglcode.SetParentComponent(wdsSystemLedgerAccounts);
    wdsSystemLedgerAccountsglcode.Name := 'wdsSystemLedgerAccountsglcode';
    wdsSystemLedgerAccountsglcode.FieldName := 'glcode';
    dsSystemLedgerAccounts.SetParentComponent(Self);
    dsSystemLedgerAccounts.Name := 'dsSystemLedgerAccounts';
    dsSystemLedgerAccounts.AutoEdit := False;
    dsSystemLedgerAccounts.DataSet := wdsSystemLedgerAccounts;
    dsSystemLedgerAccounts.Left := 496;
    dsSystemLedgerAccounts.Top := 304;
    wcCompanyGL.SetParentComponent(Self);
    wcCompanyGL.Name := 'wcCompanyGL';
    wcCompanyGL.Connection := dmData.dbConnect;
    wcCompanyGL.Left := 24;
    wcCompanyGL.Top := 160;
    wdsCompanyGL.SetParentComponent(Self);
    wdsCompanyGL.Name := 'wdsCompanyGL';
    wdsCompanyGL.Connection := dmData.dbConnect;
    wdsCompanyGL.Left := 64;
    wdsCompanyGL.Top := 160;
    wdsCompanyGLGLDESCRIPTION.SetParentComponent(wdsCompanyGL);
    wdsCompanyGLGLDESCRIPTION.Name := 'wdsCompanyGLGLDESCRIPTION';
    wdsCompanyGLGLDESCRIPTION.FieldName := 'GLDESCRIPTION';
    wdsCompanyGLFleetDesc.SetParentComponent(wdsCompanyGL);
    wdsCompanyGLFleetDesc.Name := 'wdsCompanyGLFleetDesc';
    wdsCompanyGLFleetDesc.FieldName := 'FleetDesc';
    wdsCompanyGLValueTypesDesc.SetParentComponent(wdsCompanyGL);
    wdsCompanyGLValueTypesDesc.Name := 'wdsCompanyGLValueTypesDesc';
    wdsCompanyGLValueTypesDesc.FieldName := 'ValueTypesDesc';
    wdsCompanyGLSystemDesc.SetParentComponent(wdsCompanyGL);
    wdsCompanyGLSystemDesc.Name := 'wdsCompanyGLSystemDesc';
    wdsCompanyGLSystemDesc.FieldName := 'SystemDesc';
    wdsCompanyGLGLCode.SetParentComponent(wdsCompanyGL);
    wdsCompanyGLGLCode.Name := 'wdsCompanyGLGLCode';
    wdsCompanyGLGLCode.FieldName := 'GLCode';
    wdsCompanyGLCompanygldetail_Auto.SetParentComponent(wdsCompanyGL);
    wdsCompanyGLCompanygldetail_Auto.Name := 'wdsCompanyGLCompanygldetail_Auto';
    wdsCompanyGLCompanygldetail_Auto.FieldName := 'Companygldetail_Auto';
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    btnSystemTypesSearch.AfterLoadDFMValues;
    edtSystemTypes.AfterLoadDFMValues;
    btnSearchFleetType.AfterLoadDFMValues;
    WebButton4.AfterLoadDFMValues;
    WebButton5.AfterLoadDFMValues;
    edtFleetType.AfterLoadDFMValues;
    edtValueType.AfterLoadDFMValues;
    edtGLDescription.AfterLoadDFMValues;
    wcSystemLedgerAccounts.AfterLoadDFMValues;
    wdsSystemLedgerAccounts.AfterLoadDFMValues;
    wdsSystemLedgerAccountsfleettype.AfterLoadDFMValues;
    wdsSystemLedgerAccountsvaluetype.AfterLoadDFMValues;
    wdsSystemLedgerAccountssystemtype.AfterLoadDFMValues;
    wdsSystemLedgerAccountscompanygldetail_Auto.AfterLoadDFMValues;
    wdsSystemLedgerAccountsglcode.AfterLoadDFMValues;
    dsSystemLedgerAccounts.AfterLoadDFMValues;
    wcCompanyGL.AfterLoadDFMValues;
    wdsCompanyGL.AfterLoadDFMValues;
    wdsCompanyGLGLDESCRIPTION.AfterLoadDFMValues;
    wdsCompanyGLFleetDesc.AfterLoadDFMValues;
    wdsCompanyGLValueTypesDesc.AfterLoadDFMValues;
    wdsCompanyGLSystemDesc.AfterLoadDFMValues;
    wdsCompanyGLGLCode.AfterLoadDFMValues;
    wdsCompanyGLCompanygldetail_Auto.AfterLoadDFMValues;
  end;
end;

end.